// Social and Creative - job cards (step-by-step instructions), keyed by job code. (M cards)
// A step is { text, tag }; a red STOP bar is { stop }. Loaded automatically by constants/jobCards.js.

export const division = "Social and Creative";

export const cards = {
  M1: {
    title: "Social media strategy",
    before: [
      "Brand guidelines",
      "Client discovery done",
      "Competitor list",
    ],
    steps: [
      { text: "Ask the client: how are they seen now, how do they want to be seen", tag: "Positioning" },
      { text: "Which platforms, and which matters most", tag: "Platforms" },
      { text: "Who are we talking to and what do they care about", tag: "Audience" },
      { text: "What are the goals, with numbers where possible", tag: "Goals" },
      { text: "Competitors, and what is working for them", tag: "Competitor notes" },
      { text: "What they like, what they refuse, what failed before", tag: "Preferences" },
      { text: "Who or what is available: founder time, product, photos, budget", tag: "Resources" },
      { text: "Decide 3 to 5 themes the content keeps coming back to", tag: "Themes" },
      { text: "Decide which theme goes on which platform, in what format, how often", tag: "Plan" },
      { text: "Decide the mix: how much teaching, selling, engaging, culture", tag: "Mix" },
      { text: "Write how we will know it is working, with today's numbers written down", tag: "Targets" },
      { text: "Check we actually have the people and time for this", tag: "Capacity ok" },
      { stop: "Project lead (if named), then Division Lead, then founders check" },
      { stop: "Client approves on a call, with examples and a mood board" },
    ],
    finishedWhen: "Strategy is signed, numbers are written down, and we have confirmed we can deliver it.",
  },
  M2: {
    title: "Account audit",
    before: [
      "Access to every platform",
    ],
    steps: [
      { text: "List every account they have, including old and duplicate ones", tag: "Account list" },
      { text: "Check each profile: bio, name, picture, links, contact buttons, settings", tag: "Profile check" },
      { text: "Look at what they posted and what actually worked", tag: "Content review" },
      { text: "Check if their followers are actually the people they want", tag: "Audience check" },
      { text: "Check three competitors: how often they post, what formats, what works", tag: "Competitor scan" },
      { text: "Write the findings with the most important first", tag: "Audit report" },
      { stop: "Division Lead or named project lead checks, then share with the client" },
    ],
    finishedWhen: "Audit shared, with a clear list of what to fix first.",
  },
  M3: {
    title: "Set up and fix the accounts",
    before: [
      "Brand guidelines",
      "Approved positioning",
      "Admin access",
    ],
    steps: [
      { text: "Make the handle the same across platforms, and grab any free ones", tag: "Handles" },
      { text: "Rewrite the bio to say what they DO for people, not their job title", tag: "Bio" },
      { text: "Profile and cover pictures to brand, correct sizes", tag: "Images" },
      { text: "Set up the links and where they should go", tag: "Links" },
      { text: "Set the business settings: category, contact buttons, messaging", tag: "Settings" },
      { text: "Set up highlights and pinned posts", tag: "Highlights" },
      { text: "Close or redirect duplicate and dead accounts, with client permission", tag: "Cleaned up" },
      { stop: "Client approves before you change anything live" },
    ],
    finishedWhen: "Every platform is set up, and the access list is saved.",
  },
  M4: {
    title: "Write the reply rules for a client",
    before: [
      "Approved tone of voice",
      "Client has decided who replies",
    ],
    steps: [
      { text: "Decide WHO replies: us on their behalf, or we write and they send. Decide per client, in writing", tag: "Decision" },
      { text: "How fast we reply, and in what hours", tag: "Response time" },
      { text: "How the brand sounds in a reply — not always how it sounds in a post", tag: "Tone" },
      { text: "Write ready replies for the 10 that keep coming: price, availability, complaints, praise, spam, buying, support, partnership, competitor, off topic", tag: "10 templates" },
      { text: "Write what we NEVER answer: price, legal, medical, promises the client has not made", tag: "Never list" },
      { text: "Write who to escalate to and when", tag: "Escalation" },
      { text: "Write where leads go and how fast", tag: "Lead route" },
      { text: "Write when we hide, delete or block, and who decides", tag: "Delete rules" },
      { stop: "Client approves the whole thing" },
    ],
    finishedWhen: "Rules are saved, the community person is briefed, and the 10 ready replies exist.",
  },
  M5: {
    title: "Using customer content (UGC)",
    before: [
      "You have found content worth using",
    ],
    steps: [
      { text: "Find it in tags, mentions and reviews", tag: "Found" },
      { text: "Ask the person for permission IN WRITING before using it. Screenshot the yes", tag: "Permission" },
      { text: "Adapt it to the brand: framing, captions, brand elements, correct size", tag: "Adapted" },
      { text: "Credit them the way you agreed", tag: "Credited" },
      { stop: "Division Lead or named project lead checks, client approves, then schedule" },
    ],
    finishedWhen: "Permission is saved and the post is scheduled with correct credit.",
  },
  M6: {
    title: "Getting the client's team to share posts",
    before: [
      "Agreed list of who will share",
    ],
    steps: [
      { text: "Agree who will share: founders, leadership, sales team", tag: "People list" },
      { text: "Build a kit: suggested words, the images, and a short note on how to change it in their own words", tag: "Kit" },
      { text: "Agree when the kit goes out compared to the brand post", tag: "Timing" },
      { text: "Track who actually posted and what it added", tag: "Tracking" },
    ],
    finishedWhen: "Kit is issued on a rhythm and adoption is tracked. Same words posted by 15 people reads like an advert, so the kit teaches them to change it.",
  },
  M7: {
    title: "Watching what people say (listening)",
    before: [
      "Not being done today. Start it",
    ],
    steps: [
      { text: "Find mentions of the brand, tagged and untagged", tag: "Mentions" },
      { text: "Is the mood getting better or worse than last month", tag: "Sentiment" },
      { text: "What competitors launched, what worked, what they stopped", tag: "Competitor notes" },
      { text: "New formats or platform changes worth knowing", tag: "Trends" },
      { text: "Feed it into next month's calendar and the report", tag: "Used" },
    ],
    finishedWhen: "Findings are in the monthly report and have changed next month's plan.",
  },
  M8: {
    title: "Print files",
    before: [
      "The printer's requirements, from the client",
    ],
    steps: [
      { text: "Get the printer's specs from the client BEFORE you design", tag: "Specs" },
      { text: "Design in CMYK, not RGB", tag: "CMYK file" },
      { text: "Check the images are big enough for the print size", tag: "Resolution ok" },
      { text: "Outline or embed the fonts", tag: "Fonts safe" },
      { stop: "Client approves a PDF proof BEFORE the files go to the printer" },
      { text: "Send print ready files with a short note on the specs", tag: "Delivered" },
    ],
    finishedWhen: "Print ready files handed over. The print run itself is the client's responsibility.",
  },
  M9: {
    title: "Email design",
    before: [
      "Brief and copy from Growth Systems. We only do the DESIGN",
    ],
    steps: [
      { text: "Get the brief: what it is for, who it goes to, which sending tool", tag: "Brief" },
      { text: "Structure first, then design, using the brand system", tag: "Design" },
      { text: "Keep it simple: one column where possible, real text not pictures of text", tag: "Email built" },
      { text: "Test how it looks on desktop, phone, dark mode, and one office inbox", tag: "Render test" },
      { text: "Division Lead checks, then hand back to Growth Systems to send", tag: "Handed back" },
    ],
    finishedWhen: "Design tested in all four places and handed back. Growth Systems sends it.",
  },
  M10: {
    title: "Website build — we are the builder",
    before: [
      "Growth Systems owns this job. We do the look and build it in Lovable",
      "Signed page list and APPROVED COPY for every page",
    ],
    steps: [
      { text: "Get the signed page list and the approved copy from Growth Systems", tag: "Inputs" },
      { text: "DO NOT START until the copy is approved. Building on changing copy means building twice", tag: "Ready" },
      { text: "Fix the design basics: colours, text sizes, spacing, corners. Every page uses these", tag: "Design system" },
      { text: "Build ONE page fully — the most complicated one", tag: "Pattern page" },
      { stop: "Client approves that page. They are approving the SYSTEM, not just the page" },
      { text: "Build ALL pages of one type in ONE go. Pages built days apart look different", tag: "Pages built" },
      { text: "If a page needs a new colour or size, go back and add it to the system first", tag: "System intact" },
      { text: "NEVER write or change copy. If copy is missing, put a marked placeholder and raise it", tag: "Flagged" },
      { text: "Check every page at desktop, laptop and phone, and report each one", tag: "Checked" },
      { text: "Hand back to Growth Systems for their final checks", tag: "Handed back" },
    ],
    finishedWhen: "Every page built to the approved system, checked at three sizes, placeholders flagged, handed back.",
  },
  M11: {
    title: "Looking after a live website",
    before: [
      "A site we built or took over",
    ],
    steps: [
      { text: "Make the content changes they ask for", tag: "Updates" },
      { text: "Keep the platform and plugins updated", tag: "Updated" },
      { text: "Check the backup is actually working", tag: "Backup ok" },
      { text: "Check the site is up and the forms still work", tag: "Site healthy" },
      { text: "Write down every change you make", tag: "Change log" },
      { text: "Send a short monthly summary of what changed", tag: "Monthly note" },
    ],
    finishedWhen: "Every change is logged. A site that changes with no record is a site nobody can fix later.",
  },
  M12: {
    title: "Influencer campaign",
    before: [
      "Goal, audience, budget, dates",
      "Client's position on saying it is a paid post",
    ],
    steps: [
      { text: "Decide the goal: reach, engagement, content, or sales. Each needs a different kind of creator", tag: "Goal" },
      { text: "Describe the creator we want: audience, size, platform, style, city", tag: "Creator profile" },
      { text: "Build a long list", tag: "Longlist" },
      { text: "Check each one: are the followers real, is engagement genuine, have they worked with competitors, is there anything in their old posts that would embarrass the client", tag: "Vetted" },
      { text: "Send the short list to the client with reasons", tag: "Shortlist" },
      { stop: "Client approves the creators BEFORE we contact anyone" },
      { text: "Agree in writing: what they make, dates, where we can use it and for how long, payment", tag: "Agreement" },
      { text: "Brief the message, not the exact words. Over-scripted creator posts perform worse", tag: "Creator brief" },
      { stop: "Division Lead or named project lead checks the creator's draft, then the client checks" },
      { text: "Check they have said it is a paid post BEFORE it goes live", tag: "Disclosure ok" },
      { text: "Published, and shared from the brand account if agreed", tag: "Live" },
      { text: "Report per creator: what it reached, what it did, and whether to use them again", tag: "Report" },
    ],
    finishedWhen: "Every creator reported on, content saved with its usage dates, and a recommendation on repeating.",
  },
  M13: {
    title: "Weekly note and monthly report",
    before: [
      "Numbers from the platforms",
      "The community and lead logs",
    ],
    steps: [
      { text: "WEEKLY, to Shreya by Friday 2 PM: what went out, how it did, what is coming, community highlights, leads sent, what is waiting on the client", tag: "Weekly note" },
      { text: "MONTHLY, to Shreya between the 25th and 28th: reach, engagement rate, follower change, profile visits, clicks, saves, shares", tag: "Numbers" },
      { text: "Compare with the targets in the strategy and with last month", tag: "Comparison" },
      { text: "Best and worst posts — with a REASON, not just a ranking", tag: "Analysis" },
      { text: "Which themes and formats actually got attention", tag: "Insight" },
      { text: "Community: how many messages, how fast we replied, the mood, notable chats", tag: "Community section" },
      { text: "Leads sent to the client and how fast", tag: "Leads" },
      { text: "What we planned versus what actually went out", tag: "Delivered vs planned" },
      { text: "What we were waiting on from the client, and for how long. Say it plainly, not as a complaint", tag: "Dependency note" },
      { text: "What we suggest for next month", tag: "Recommendations" },
    ],
    finishedWhen: "Weekly report with Shreya by Friday 2 PM. Monthly report with Shreya between the 25th and 28th. Card R1 has the full rule.",
  },
};
